export const CHEMICAL_INDICES_GET_REQUEST = 'CHEMICAL_INDICES_GET_REQUEST';
export const CHEMICAL_INDICES_GET_SUCCESS = 'CHEMICAL_INDICES_GET_SUCCESS';
export const CHEMICAL_INDICES_GET_ERROR = 'CHEMICAL_INDICES_GET_ERROR';
export const CHEMICAL_INDICES_GET_BY_KEY_REQUEST = 'CHEMICAL_INDICES_GET_BY_KEY_REQUEST';
export const CHEMICAL_INDICES_GET_BY_KEY_SUCCESS = 'CHEMICAL_INDICES_GET_BY_KEY_SUCCESS';
export const CHEMICAL_INDICES_GET_BY_KEY_ERROR = 'CHEMICAL_INDICES_GET_BY_KEY_ERROR';
export const CHEMICAL_INDICES_ADD_REQUEST = 'CHEMICAL_INDICES_ADD_REQUEST';
export const CHEMICAL_INDICES_ADD_SUCCESS = 'CHEMICAL_INDICES_ADD_SUCCESS';
export const CHEMICAL_INDICES_ADD_ERROR = 'CHEMICAL_INDICES_ADD_ERROR';
export const CHEMICAL_INDICES_EDIT_REQUEST = 'CHEMICAL_INDICES_EDIT_REQUEST';
export const CHEMICAL_INDICES_EDIT_SUCCESS = 'CHEMICAL_INDICES_EDIT_SUCCESS';
export const CHEMICAL_INDICES_EDIT_ERROR = 'CHEMICAL_INDICES_EDIT_ERROR';
export const CHEMICAL_INDICES_DELETE_REQUEST = 'CHEMICAL_INDICES_DELETE_REQUEST';
export const CHEMICAL_INDICES_DELETE_SUCCESS = 'CHEMICAL_INDICES_DELETE_SUCCESS';
export const CHEMICAL_INDICES_DELETE_ERROR = 'CHEMICAL_INDICES_DELETE_ERROR';
